export default __webpack_public_path__ + "static/media/unnamed-removebg-preview.845ddf95.png";